import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-ts"]
const _hoisted_2 = ["data-ts"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["data-ts"]
const _hoisted_5 = {
  key: 5,
  "data-ts": `table-cell`
}

import copyToClipboard from '@shared/utils/copyToClipboard';
import formatCurrency from '@shared/utils/formatCurrency';
import useFormatStatus from '@shared/utils/useFormatStatus';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import BtnIcon from '../BtnIcon/BtnIcon.vue';
import CountryFlag from '../CountryFlag/CountryFlag.vue';
import StatusBadge from '../StatusBadge/StatusBadge.vue';
import { CelFormatType } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TableFormattedCell',
  props: {
    index: {},
    content: {},
    type: {},
    currency: {}
  },
  setup(__props: any) {

dayjs.extend(utc);


return (_ctx: any,_cache: any) => {
  return (_ctx.type === 'date' && _ctx.content)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        "data-ts": `table-row-date-${_ctx.index}`,
        class: "nowrap"
      }, _toDisplayString(_unref(dayjs).utc(_ctx.content as Date).format('DD-MM-YYYY HH:mm')), 9, _hoisted_1))
    : (_ctx.type === 'code' && _ctx.content)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex nowrap items-center",
          "data-ts": `table-row-code-${_ctx.index}`
        }, [
          _createElementVNode("p", {
            class: "text-monospaced text-neutral-500 items-end gap-4",
            title: _ctx.content
          }, _toDisplayString(_ctx.content), 9, _hoisted_3),
          (_ctx.content && _ctx.content)
            ? (_openBlock(), _createBlock(BtnIcon, {
                key: 0,
                style: {"flex-shrink":"0"},
                class: "ml-1",
                ariaLabel: "Copy",
                title: "Copy",
                "icon-name": "bx-copy",
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(copyToClipboard)(_ctx.content as string, $event)))
              }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : (_ctx.type === 'currency' && _ctx.content)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.content)
              ? (_openBlock(), _createBlock(CountryFlag, {
                  key: 0,
                  "data-ts": `table-row-currency-${_ctx.index}`,
                  label: _ctx.content as string,
                  flag: _ctx.content as string
                }, null, 8, ["data-ts", "label", "flag"]))
              : _createCommentVNode("", true)
          ], 64))
        : (
			(_ctx.type === 'value' && _ctx.content && _ctx.currency) ||
			(_ctx.type === 'value' && _ctx.content === 0 && _ctx.currency)
		)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: "text-weight-bold",
              "data-ts": `table-row-value-${_ctx.index}`
            }, _toDisplayString(_unref(formatCurrency)(_ctx.content as number, _ctx.currency as any)), 9, _hoisted_4))
          : (_ctx.type === 'badge' && _ctx.content)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (_ctx.content)
                  ? (_openBlock(), _createBlock(StatusBadge, {
                      key: 0,
                      "data-ts": `table-row-badge-${_ctx.index}`,
                      label: _ctx.content as string,
                      status: _unref(useFormatStatus)(_ctx.content as string)
                    }, null, 8, ["data-ts", "label", "status"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.content ?? '-'), 1))
}
}

})